import { createSelector } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import {
  INavigationApplicationInterface,
  INavigationBarItemInterface,
  INavigationConfigurationInterface
} from '@ispm/navigation/interfaces';

export const selectNavigationFeature = (state: IgenomicsState): INavigationConfigurationInterface => state.navigation;

export const selectNavigationListFeature =  () => {
  return createSelector(selectNavigationFeature, (data) => data.navigation.items);
};

export const selectNavigationItemCurrentSelectedFeature =  () => {
  return createSelector(selectNavigationFeature, (data) => data.currentSelected || null);
};

export const selectNavigationItemSelectedFeature =  () => {
  return createSelector(selectNavigationFeature, (data) => data.navigation.selected);
};

export const selectNavigationItemByAppId =
  createSelector(
    selectNavigationFeature,
    (state, props) => {
        if (state.navigation && state.navigation.items) {
            const temp: Array<INavigationBarItemInterface> = state.navigation.items.filter(navigationItem => navigationItem.appid === props.id && navigationItem.enable);
            // console.log("Navigation Selector : select enabled navigation items by app : " + temp);
            return temp;
        }
        return null;
    }
  );

export const selectNavigationConfiguration = createSelector(
    selectNavigationFeature, (data) => data
);

export const selectCurrentSelectedApplication =  createSelector(
  selectNavigationFeature, (data) => {
    if (data.currentApp && data.currentApp.id) {
      return data.currentApp;
    } else {
      try {
        return JSON.parse(sessionStorage.getItem('currentApplication'));
      } catch (e) {
        console.error('Exception caught at parsing of current application', e);
        return null;
      }
    }
  }
);

export const selectCurrentAppAlias = createSelector(
  selectCurrentSelectedApplication, (data: INavigationApplicationInterface) => {
    return data.alias;
  }
);
